// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foto-body-progress-container .main-container {
    padding: 24px 15px;
    border-radius: 16px;
    background-color: var(--white);
    width: 100%;
    box-shadow: 4px 6px 12px 0 #181C270A;
}

.foto-body-progress-container .main-container .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    text-align: center;
}

.foto-body-progress-container .main-container .title > span {
    color: var(--orange);
}

.foto-body-progress-container .main-container .img-container {
    padding: 16px;
    margin: 16px 0 22px;
    border-radius: 16px;
    background-color: var(--light-gray);

    display: flex;
    flex-direction: column;
    align-items: center;
}

.foto-body-progress-container .main-container .img-container .period {
    padding: 6px 16px;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: var(--white);
    border-radius: 16px;
    border: 2px solid var(--orange);

    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    text-align: center;
    color: var(--orange);
}

.foto-body-progress-container .main-container .img-container img {
    width: 100%;
}

.foto-body-progress-container .main-container .data-model {
    display: flex;
    justify-content: space-between;

    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
}

.foto-body-progress-container .main-container .data-model .burning-fat {
    font-weight: 700;
}


.foto-body-progress-container .description {
    margin-top: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    text-align: left;
    color: var(--dark-gray);
}

.foto-body-progress-container .description > span {
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.foto-body-progress.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mCAAmC;;IAEnC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;;IAE/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".foto-body-progress-container .main-container {\n    padding: 24px 15px;\n    border-radius: 16px;\n    background-color: var(--white);\n    width: 100%;\n    box-shadow: 4px 6px 12px 0 #181C270A;\n}\n\n.foto-body-progress-container .main-container .title {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 26px;\n    text-align: center;\n}\n\n.foto-body-progress-container .main-container .title > span {\n    color: var(--orange);\n}\n\n.foto-body-progress-container .main-container .img-container {\n    padding: 16px;\n    margin: 16px 0 22px;\n    border-radius: 16px;\n    background-color: var(--light-gray);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.foto-body-progress-container .main-container .img-container .period {\n    padding: 6px 16px;\n    margin-top: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-color: var(--white);\n    border-radius: 16px;\n    border: 2px solid var(--orange);\n\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 21px;\n    text-align: center;\n    color: var(--orange);\n}\n\n.foto-body-progress-container .main-container .img-container img {\n    width: 100%;\n}\n\n.foto-body-progress-container .main-container .data-model {\n    display: flex;\n    justify-content: space-between;\n\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 26px;\n}\n\n.foto-body-progress-container .main-container .data-model .burning-fat {\n    font-weight: 700;\n}\n\n\n.foto-body-progress-container .description {\n    margin-top: 16px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 15.6px;\n    text-align: left;\n    color: var(--dark-gray);\n}\n\n.foto-body-progress-container .description > span {\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
